// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @ commons
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ constants
const {
    ACCOUNT_INTERVENTION_OWNER,
    CHECKING_ACCOUNT_TYPE,
    FOURTH_STEP
} = require('constants/index');
const { BLOCKED_ACCOUNTS_INSURANCES_HOME, BLOCKED_ACCOUNTS_INSURANCES_HOME_RELATED } = require('constants/operationCodesAccounts');

class InsuranceRequestWizardStep4AccountSection extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const { getBlockedAccounts, immAccounts, isBlockedAccountsEnabled, isRelated, setData, immInsuranceWizardStep } = this.props;
        const accountsIndexes = this.getAccountsIndexes();
        const blockedAccountsCode = isRelated ? BLOCKED_ACCOUNTS_INSURANCES_HOME_RELATED : BLOCKED_ACCOUNTS_INSURANCES_HOME;
        const accountId = immInsuranceWizardStep.get('accountId');
        if(immAccounts.get('blockedAccountsIds').size >= 1) {
            const accountIdIsBlocked = immAccounts.get('blockedAccountsIds').includes(accountId);
            setData(FOURTH_STEP, { accountIdIsBlocked });
        }
        if (!isBlockedAccountsEnabled) {
            this.setAccount();
        } else if (!immAccounts.get('blockedAccountsSuccess')) {
            const accounts = accountsIndexes.map(id => immAccounts.getIn(['byId', id]));
            getBlockedAccounts(accounts, blockedAccountsCode);
        }
    }

    componentDidUpdate(prevProps) {
        const { immAccounts } = this.props;

        if (!immAccounts.get('blockedAccountsOrNegativeAll') &&
            prevProps.immAccounts.get('blockedAccountsOrNegativeAll') !== immAccounts.get('blockedAccountsOrNegativeAll')) {
            this.setAccount();
        }
    }

    componentWillUnmount() {
        const { resetBlockedAccounts } = this.props;

        resetBlockedAccounts();
    }

    getAccountsList(accounts, accountsMap) {
        return accounts.filter(accountId => {
            const accountHolder = accountsMap.getIn([accountId, 'interventionType']);
            const accountProduct = accountsMap.getIn([accountId, 'newProduct']);
            return accountHolder === ACCOUNT_INTERVENTION_OWNER && accountProduct === CHECKING_ACCOUNT_TYPE
        });
    }

    getAccountsIndexes() {
        const {
            immAccounts,
        } = this.props;
        const accountsMap = immAccounts.get('byId');
        return this.getAccountsList(immAccounts.get('byOrder'), accountsMap);
    }

    setAccount() {
        const { onhandleAccountChange } = this.props;
        const accountsIndexes = this.getAccountsIndexes();

        if (accountsIndexes.size === 1) {
            onhandleAccountChange(accountsIndexes.get(0));
        }
    }


    validateAccountBanlance() {
        const {immInsuranceWizardStep} = this.props;
        const accountBalance = immInsuranceWizardStep.get('accountBalance');
        const totalCost = immInsuranceWizardStep.get('totalCost');
        const startDate = immInsuranceWizardStep.get('startDate');
        const diffDays = moment(startDate).diff(moment().startOf('day'), 'days');
        return diffDays === 0 ?  accountBalance < totalCost : false;
    }

    render() {
        const {
            immInsuranceWizardStep,
            immAccounts,
            isRelated,
            onhandleAccountChange
        } = this.props;

        const accountsMap = immAccounts.get('byId');
        const accountId = immInsuranceWizardStep.get('accountId');
        const accountIsFetching = !immInsuranceWizardStep.get('isFetchingPricing') && !immInsuranceWizardStep.get('isFetchingAccount');
        const accountRequiredError = immInsuranceWizardStep.get('fieldErrors') && !accountId;
        const accountValidation =  this.validateAccountBanlance();
        const accountNotEnoughBalanceError = !isRelated && immInsuranceWizardStep.get('fieldErrors') && accountValidation;
        const accountErrorMsg = accountRequiredError ?
            formatText('insuranceRequestHome-step4AdditionalInfoRequiredInput') :
            formatText('insuranceRequestHome-step4NotEnoughBalanceMessage');
        const disclaimer = {
            warning: 'insuranceRequestHome-insuranceRequestHome_step4BlockedAccountsWarning',
            important: 'insuranceRequestHome-insuranceRequestHome_step4BlockedAccountsImportant'
        }

        return !immAccounts.get('blockedAccountsLoading') ? (
            <div className="insurance-request-wizard-step-four__payment row">
                <div className="col-xs-12">
                    <DropdownAccounts
                        blockedAccountsAll={immAccounts.get('blockedAccountsAll')}
                        blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                        disclaimer={disclaimer}
                        label="insuranceRequestHome-step4Account"
                        immAccounts={accountsMap}
                        currentAccountId={accountId}
                        accountsIndexes={this.getAccountsIndexes().toJS()}
                        onAccountChange={(event) => onhandleAccountChange(event)}
                        error={accountRequiredError || accountNotEnoughBalanceError}
                        errorMsg={accountErrorMsg}
                        enabled={accountIsFetching}
                        showAvailableBalance
                    />
                </div>
            </div>
        ) : <LoadingSection />;
    }
}

InsuranceRequestWizardStep4AccountSection.propTypes = {
    getBlockedAccounts: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    isBlockedAccountsEnabled: PropTypes.bool.isRequired,
    isRelated: PropTypes.bool.isRequired,
    onhandleAccountChange: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
};

InsuranceRequestWizardStep4AccountSection.defaultProps = {
    isRelated: false
};

module.exports = InsuranceRequestWizardStep4AccountSection;
